import React, { useEffect, useState } from 'react';
import styles from './DistributorErrorEmailAlerts.module.scss';
import { $t } from "../../helpers/translator";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import { FiInfo } from 'react-icons/fi';
import { useDispatch } from "react-redux";
import { FaEdit } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { GrServices } from 'react-icons/gr';
import { RiCustomerServiceLine } from 'react-icons/ri';
import Modal from "../miscellaneous/Modal/Modal";
import _ from "lodash";
import { $validate } from "../../helpers/formValidator";
import api from "../../helpers/api";
import { setAlert } from "../../store/alerts-slice";

import Input from "../miscellaneous/Input/Input";


const DistributorErrorEmailAlerts = (props) => {
    const dispatch = useDispatch();

    const [ userCallsSelected, setUserCallsSelected ] = useState([])
    const [ machineErrorsSelected, setMachineErrorsSelected ] = useState([])
    const [ showAlertEmailModal, setAlertEmailModal ] = useState(false)
    const [ formSent, setFormSent ] = useState(false)
    const [ loading, setLoading ] = useState(false);
    const [ notificationsMail, setNotificationsMail ] = useState('');
    const [ newNotificationsMail, setNewNotificationsMail ] = useState('');
    const [ validations, setValidations ] = useState({
        notificationsMail: {
            rules: [ 'required', 'email' ],
            errors: []
        },
    });

    const userCalls = [
        { value: 1, label: $t('global.account.enabled') },
        { value: 0, label: $t('global.account.disabled') },
    ];
    const machineErrors = [
        { value: 1, label: '1 ' + $t('global.account.error') },
        { value: 3, label: '3 ' + $t('global.account.errors') },
        { value: 5, label: '5 ' + $t('global.account.errors') },
        { value: 0, label: $t('global.account.disabled') }
    ];

    useEffect(() => {
        (async function () {
            await getDistributorData();
        })()
    }, []);

    async function getDistributorData() {
        setLoading(true);

        try {
            let res = await api.get(`/account/distributor?distributor_id=${props.distributorId}`);
            if (!res || !res.success) {
                return;
            }

            setNotificationsMail(res.data.data.notificationsMail);
            setNewNotificationsMail(res.data.data.notificationsMail)
            setMachineErrorsSelected(machineErrors[ _.findIndex(machineErrors, function (o) {
                return o.value === res.data.data.machine_assignment_alerts
            }) ]);
            setUserCallsSelected(userCalls[ _.findIndex(userCalls, function (o) {
                return o.value === res.data.data.service_call_alerts
            }) ])

        } catch (e) {
            console.error('err,', e);
        }
    }

    async function updateDistributorData(payload) {
        setLoading(true);
        try {
            let res = await api.post(`/account/distributor?id=${props.distributorId}`, payload);
            if (!res.success) {
                dispatch(setAlert({ type: 'error' }))
                return;
            }

            await getDistributorData();
            dispatch(setAlert({ type: 'success' }))

        } catch (e) {
            console.error('err getting countries,', e);
        }
    }

    function validateField(id, value, rules) {
        let errorsArr = $validate(value, rules)

        let newValidations = { ...validations }
        newValidations[ id ].errors = errorsArr;
        setValidations(newValidations)

        return errorsArr.length
    }

    function closeModals() {
        setAlertEmailModal(false)
    }

    async function formSentClickHandler() {
        setFormSent(true);

        let errors = validateField('notificationsMail', newNotificationsMail, validations.notificationsMail.rules);
        if (errors) {
            return;
        }

        try {
            let res = await api.post(`/account/distributor?id=${props.distributorId}`, { notificationsMail: newNotificationsMail });
            if (res.success) {
                dispatch(setAlert({ type: 'success' }))
                // props.emitClose();
                closeModals();
                await getDistributorData();
                return;
            }
            dispatch(setAlert({ type: 'error' }))
        } catch (e) {
            console.error(e);
        }
    }

    function renderChangeAlertName() {
        return (
            <div className={ styles.container }>
                <div className={ 'alma-box-header' }>
                    <div>
                        <h3>{ props.mode === 'add' ? $t('global.account.changeNotificationEmail') : $t('global.account.changeNotificationEmail') }</h3>
                    </div>
                </div>
                <div className={ 'alma-box-content' }>
                    <div className={ 'alma-fields-row' }>
                        <div className={ 'alma-field-container' }>
                            <div className={ 'alma-field-header' }>{ $t('global.account.newEmail') }</div>
                            <Input name="email"
                                tooltip={ $t('global.account.userAndMachineAlerts') }
                                className={ `${'alma-input'}` }
                                type="text"
                                value={ newNotificationsMail }
                                placeholder={ $t('global.account.newEmail') }
                                onChange={ (data) => {
                                    setNewNotificationsMail(data.target.value);
                                    validateField('notificationsMail', data.target.value, validations.notificationsMail.rules);
                                } } />
                            <div
                                className={ 'alma-field-error' }>{ formSent ? validations.notificationsMail.errors[ 0 ] : '' }</div>
                        </div>
                    </div>
                </div>
                <div className={ 'alma-box-footer' }>
                    <div />
                    <div className={ 'alma-button' } onClick={ () => formSentClickHandler() }>
                        { props.mode === 'add' ? $t('global.account.changeNotificationEmail') : $t('global.account.changeNotificationEmail') }
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={ `${styles[ 'container' ]} alma-box` }>
            <div className={ `alma-box-header` }>
                <span><h3>{ $t('global.account.alertSettings') }</h3></span>
                <Tooltip
                    content={ $t('global.account.alertSettingsInfo') }>
                    <FiInfo className={ `${styles[ 'info-icon' ]}` } />
                </Tooltip>
            </div>
            <div>
                <div className={ `${styles[ 'row' ]}` }>
                    <Tooltip
                        content={ $t('global.account.userAndMachineAlerts') }>
                        <HiOutlineMail className={ `${styles[ 'data-icon' ]}` } />
                    </Tooltip>
                    <div className={ `${styles[ 'header' ]}` }>{ $t('global.myDetails.notificationsMail') }:</div>
                    <div className={ `${styles[ 'value' ]}` }>{ notificationsMail }</div>
                    <FaEdit className={ `${styles[ 'edit-icon' ]}` } onClick={ () => setAlertEmailModal(true) } />
                </div>
                <div className={ `${styles[ 'row' ]}` }>
                    <Tooltip
                        content={ $t('global.account.userCallsInfo') }>
                        <RiCustomerServiceLine className={ `${styles[ 'data-icon' ]}` } />
                    </Tooltip>
                    <div className={ `${styles[ 'header' ]}` }>{ $t('global.myDetails.userCalls') }:</div>
                    <div className={ `${styles[ 'value' ]} ${styles[ 'select' ]}` }>
                        <MultiSelect
                            options={ userCalls }
                            selected={ userCallsSelected }
                            onValueChange={ async (data) => {
                                setUserCallsSelected(data);
                                // setPayload({...payload, service_call_alerts: data.value});
                                // validateField('userCalls', data.value, validations.userCalls.rules)
                                await updateDistributorData({
                                    service_call_alerts: data.value
                                })
                            } }
                        />
                    </div>
                </div>
                <div className={ `${styles[ 'row' ]}` }>
                    <Tooltip
                        content={ $t('global.myDetails.machineErrosInfo') }>
                        <GrServices className={ `${styles[ 'data-icon' ]}` } />
                    </Tooltip>
                    <div className={ `${styles[ 'header' ]}` }>{ $t('global.myDetails.machineErros') }:</div>
                    <div className={ `${styles[ 'value' ]} ${styles[ 'select' ]}` }>
                        <MultiSelect
                            options={ machineErrors }
                            selected={ machineErrorsSelected }
                            onValueChange={ async (data) => {
                                setMachineErrorsSelected(data);
                                // setPayload({...payload, machine_assignment_alerts: data.value});
                                await updateDistributorData({ machine_assignment_alerts: data.value })
                                // validateField('machineErrors', data.value, validations.machineErrors.rules)
                                // updateMachineErrors(data.value)
                            } }
                        />
                    </div>
                </div>
            </div>
            <Modal content={ renderChangeAlertName() }
                onClose={ closeModals.bind(this) }
                visible={ showAlertEmailModal } />
        </div>
    );
}

DistributorErrorEmailAlerts.defaultProps = {
    user: null,

}

export default DistributorErrorEmailAlerts;
